<template>
  <div style="margin:10px">
    <el-row :gutter="10">
      <el-col :span="elTreeLeftShow?5:0" :xs="24">
        <el-card class="el-card-tree" shadow="hover" :style="{ 'background-color': '#fff', height: cardTreeHeigth}">
          <el-input
            placeholder="请输入关键字过滤"
            v-model="userSearch"
            prefix-icon="el-icon-search"
            size="small"
            clearable
          />
          <div class="div-el-tree" :style="{'height': pageHeight}">
            <el-tree
              class="el-tree-left"
              ref="userTree"
              node-key="nodeId"
              accordion
              style="margin-top:10px;"
              :data="userTree"
              :default-expanded-keys="userTreeDefExpa"
              :props="{ label: 'name', children: 'childs'}"
              :highlight-current="true"
              :expand-on-click-node="false"
              :filter-node-method="onTreeFilter"
              @node-click="onUserTreeClick"
            />
          </div>
        </el-card>
      </el-col>
      <el-col  :span="elTreeLeftShow?19:24" :xs="24" class="el-col-content">
        <i :class="elTreeLeftShow?'el-icon-s-fold':'el-icon-s-unfold'" @click="elTreeLeftShow=!elTreeLeftShow"></i>
        <el-card shadow="hover" style="background-color: #fff">
          <el-row>
            <!-- 查询条件 -->
            <el-col class="pagin" ref="query">
              <el-row class="mb5 mt2 ml2">
                <div class="inline-block mr10">
                  <div class="absolute pr1 py1 h12 color-title" style="position: absolute;">名称:</div>
                  <div class="pl4-6 width-200">
                    <el-input v-model="formQuery.userDevName" size="small" placeholder="名称" clearable></el-input>
                  </div>
                </div>
                <div class="inline-block mr10">
                  <div class="absolute pr1 py1 h12 color-title" style="position: absolute;">识别码:</div>
                  <div class="pl4-6 width-200">
                    <el-input v-model="formQuery.sn" size="small" placeholder="识别码" clearable></el-input>
                  </div>
                </div>
                <div class="inline-block mr10">
                  <div class="absolute pr1 py1 h12 color-title" style="position: absolute;">状态:</div>
                  <div class="pl4-6 width-200">
                    <el-select clearable v-model="formQuery.status" placeholder="请选择状态" size="small">
                      <el-option v-for="(item, index) in dictStatus" :key="index" :label="item.codeName" :value="item.codeId"></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="inline-block mr10" v-if="showMore">
                  <div class="absolute pr1 py1 h12 color-title" style="position: absolute;">在线状态:</div>
                  <div class="pl4-6 width-200">
                    <el-select clearable v-model="formQuery.lineStatus" placeholder="请选择在线状态" size="small">
                      <el-option v-for="(item, index) in dictLineStatus" :key="index" :label="item.codeName" :value="item.codeId"></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="inline-block mr10" v-if="showMore&&userInfo.userLevel=='2'">
                  <div class="absolute pr1 py1 h12 color-title" style="position: absolute;">工厂:</div>
                  <div class="pl4-6 width-200">
                    <el-select v-model="formQuery.userFactId" filterable placeholder="请选择工厂" clearable size="small" class="full" @clear="onSelectClear('userFactIdCacheList')" :filter-method="val=>onSelectFilter(val, formQuery, 'userFactId', 'userFactIdCacheList')">
                        <el-option v-for="(item, index) in userFactIdCacheList" :key="index" :label="item.codeName" :value="item.codeId"></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="inline-block mr10" v-if="showMore&&(userInfo.userLevel=='2'||userInfo.userLevel=='3')">
                  <div class="absolute pr1 py1 h12 color-title" style="position: absolute;">仓库:</div>
                  <div class="pl4-6 width-200">
                    <el-select v-model="formQuery.userStoreId" filterable placeholder="请选择仓库" clearable size="small" class="full" @clear="onSelectClear('userStoreIdCacheList')" :filter-method="val=>onSelectFilter(val, formQuery, 'userStoreId', 'userStoreIdCacheList')">
                        <el-option v-for="(item, index) in userStoreIdCacheList" :key="index" :label="item.codeName" :value="item.codeId"></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="inline-block mr10" v-if="showMore">
                  <div class="absolute pr1 py1 h12 color-title" style="position: absolute;">点位:</div>
                  <div class="pl4-6 width-200">
                    <el-select v-model="formQuery.userPointId" filterable placeholder="请选择点位" clearable size="small" class="full" @clear="onSelectClear('userPointIdCacheList')" :filter-method="val=>onSelectFilter(val, formQuery, 'userPointId', 'userPointIdCacheList')">
                        <el-option v-for="(item, index) in userPointIdCacheList" :key="index" :label="item.codeName" :value="item.codeId"></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="inline-block mr10" v-if="showMore">
                  <div class="absolute pr1 py1 h12 color-title" style="position: absolute;">网关:</div>
                  <div class="pl4-6 width-200">
                    <el-select v-model="formQuery.userGwId" filterable placeholder="请选择网关" clearable size="small" class="full" @clear="onSelectClear('userGwIdCacheList')" :filter-method="val=>onSelectFilter(val, formQuery, 'userGwId', 'userGwIdCacheList')">
                        <el-option v-for="(item, index) in userGwIdCacheList" :key="index" :label="item.codeName" :value="item.codeId"></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="inline-block mr4">
                  <el-button v-if="checkPermission(funcData, 'query')" size="small" type="primary" icon="el-icon-search" @click="onQuery">查找</el-button>
                  <el-button v-if="checkPermission(funcData, 'add')" size="small" type="primary" icon="el-icon-plus" @click="onShowAdd">添加</el-button>
                </div>
                <!-- 批量操作按扭 -->
                <el-dropdown v-if="checkPermission(funcData, 'batchRemove,batchEnable,batchDisable')" size="small" type="primary" trigger="click">
                  <el-button type="primary" size="small">
                    批量操作<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-if="checkPermission(funcData, 'batchRemove')" class="px10" @click.native="onBatchRemove">批量删除</el-dropdown-item>
                    <el-dropdown-item v-if="checkPermission(funcData, 'batchEnable')" class="px10" @click.native="onBatchEnable">批量启用</el-dropdown-item>
                    <el-dropdown-item v-if="checkPermission(funcData, 'batchDisable')" class="px10" @click.native="onBatchDisable">批量禁用</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <el-switch @change="onRefreshAuto" style="margin-left: 10px;" v-model="refreshAuto" active-text="自动刷新"></el-switch>
                <el-link type="primary" @click="showMore=!showMore" style="margin-left:10px;">{{showMore?'收起∧':'展开∨'}}</el-link>
              </el-row>
              <el-row class="div-level" v-if="divLevel.length > 0">
                <label>层级:</label>
                <span v-for="(tree, index) in divLevel" :key="index"><el-link type="success" @click="onDivClick(tree)">{{tree.name}}</el-link></span>
              </el-row>
            </el-col>

            <!-- 表格  -->
            <el-col v-if="!checkPermission(funcData, 'query')" :style="{height: pageHeight,lineHeight: pageHeight}" class="noPer">没有列表查询权限</el-col>
            <el-col v-else>
              <el-table
                ref="table"
                v-loading="pageLoading"
                element-loading-text="拼命加载中"
                size="mini"
                stripe
                border
                style="width: 100%"
                :height="pageHeight"
                :data="dataList"
                :header-cell-class-name="onHeaderClass"
                @sort-change="onSortChange"
                @selection-change="onSelectionChange"
                ><!-- :default-sort = "{prop: 'date', order: 'descending'}" -->

                <el-table-column
                  v-if="checkPermission(funcData, 'batchRemove,batchEnable,batchDisable')"
                  type="selection"
                  width="45"></el-table-column>

                <el-table-column align="center" label="序号" type="index"></el-table-column>

                <el-table-column width="148px" align="center" label="操作">
                  <template slot-scope="scope">
                    <el-button v-if="checkPermission(funcData, 'detail')" size="mini" title="查看" circle type="success" icon="el-icon-document" @click="onDetail(scope.$index, scope.row)"></el-button>
                    <el-button v-if="checkPermission(funcData, 'modify')" size="mini" title="编辑" circle type="warning" icon="el-icon-edit" @click="onShowEdit(scope.$index, scope.row)"></el-button>
                    <el-button v-if="checkPermission(funcData, 'remove')" size="mini" title="删除" circle type="danger" icon="el-icon-delete" @click="onPageRemove(scope.$index, scope.row)"></el-button>
                    <el-button v-if="checkPermission(funcData, 'userSub')" size="mini" title="终端设备" circle type="primary" icon="el-icon-odometer" @click="$router.push({name:'userplatDevUsersub', query:{userDevId:scope.row.userDevId}})"></el-button>
                  </template>
                </el-table-column>

                <el-table-column
                  show-overflow-tooltip
                  prop="userDevName"
                  label="名称"
                  sortable="custom"
                  >
                </el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  width="80px"
                  prop="value1"
                  label="温度"
                  sortable="custom"
                  >
                  <template slot-scope="scope">{{scope.row.value1|append('℃')}}</template>
                </el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  width="80px"
                  prop="value2"
                  :label="userInfo.userHumName"
                  sortable="custom"
                  >
                  <template slot-scope="scope">{{scope.row.value2|append(userInfo.userHumUnit)}}</template>
                </el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  width="80px"
                  prop="lineStatus"
                  label="在线状态"
                  sortable="custom"
                  >
                  <template slot-scope="scope">
                    <el-tag size="small" type="warning" v-if="scope.row.lineStatus=='0'">{{scope.row.lineStatus|dict(dictLineStatus)}}</el-tag>
                    <el-tag size="small" type="success" v-else-if="scope.row.lineStatus=='1'">{{scope.row.lineStatus|dict(dictLineStatus)}}</el-tag>
                    <el-tag size="small" v-else-if="scope.row.lineStatus=='2'">{{scope.row.lineStatus|dict(dictLineStatus)}}</el-tag>
                    <el-tag size="small" v-else-if="scope.row.lineStatus=='3'">{{scope.row.lineStatus|dict(dictLineStatus)}}</el-tag>
                    <el-tag size="small" type="danger" v-else-if="scope.row.lineStatus=='4'">{{scope.row.lineStatus|dict(dictLineStatus)}}</el-tag>
                    <el-tag size="small" v-else-if="scope.row.lineStatus=='5'">{{scope.row.lineStatus|dict(dictLineStatus)}}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  :width="checkPermission(funcData, 'enable,disable')?'110px':'80px'"
                  prop="status"
                  label="状态"
                  sortable="custom"
                  >
                  <template slot-scope="scope">
                    <el-switch
                      v-if="checkPermission(funcData, 'enable,disable')"
                      :disabled="((scope.row.status!='1' && !checkPermission(funcData, 'enable')) || (scope.row.status=='1' && !checkPermission(funcData, 'disable')))"
                      style="margin-right: 5px;"
                      @change="onSwitch(scope.$index, scope.row)"
                      v-model="scope.row.switch"
                      active-color="#409eff"
                      inactive-color="#dcdfe6">
                    </el-switch>
                    <el-tag size="small" type="success" v-if="scope.row.status == '1'">{{scope.row.status|dict(dictStatus)}}</el-tag>
                    <el-tag size="small" type="danger" v-else>{{scope.row.status|dict(dictStatus)}}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  width="160px"
                  prop="sn"
                  label="识别码"
                  sortable="custom"
                  >
                  <template slot-scope="scope">
                    {{scope.row.sn}}/{{scope.row.userDevAddr}}
                  </template>
                </el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  width="80px"
                  prop="timeTaskDelay"
                  label="定时(s)"
                  sortable="custom"
                  >
                </el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  width="140px"
                  prop="updateTime"
                  label="更新时间"
                  sortable="custom"
                  >
                </el-table-column>
              </el-table>
            </el-col>

            <!-- 分页 -->
            <el-col class="pagination">
              <el-pagination
                background
                :current-page="pageParam.pageNo"
                :page-sizes="[30, 50, 100, 200, 500, 1000]"
                @size-change="onSizeChange"
                @current-change="onCurrentChange"
                layout="prev, pager, next, total, jumper, sizes"
                :total="pageTotal">
              </el-pagination>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
    <!-- 详情弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogDetail" width="1000px" top="8vh">
      <template slot="title"><i class="el-icon-document" /> 设备详情</template>
      <el-descriptions class="detail-div" :column="3" size="small" border labelClassName="detail-label" contentClassName="detail-content">
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-warning-outline"></i>设备ID</template>
          {{dataDetail.userDevId}}
        </el-descriptions-item>
        <el-descriptions-item span="2">
          <template slot="label"><i class="el-icon-tickets"></i>设备名称</template>
          {{dataDetail.userDevName}}
        </el-descriptions-item>
        <el-descriptions-item span="3">
          <template slot="label"><i class="el-icon-tickets"></i>设备描叙</template>
          {{dataDetail.userDevDesc}}
        </el-descriptions-item>
        <el-descriptions-item span="3">
          <template slot="label"><i class="el-icon-warning-outline"></i>厂商设备</template>
          {{dataDetail.produerId|dict(produerIdCacheListCopy)}}
          >
          {{dataDetail.devId|dict(devIdCacheListCopy)}}
        </el-descriptions-item>
        <el-descriptions-item span="3">
          <template slot="label"><i class="el-icon-warning-outline"></i>商户设备</template>
          {{dataDetail.merId|dict(merIdCacheListCopy)}}
          >
          {{dataDetail.merGwId|dict(merGwIdCacheListCopy)}}
          >
          {{dataDetail.merDevId|dict(merDevIdCacheListCopy)}}
        </el-descriptions-item>
        <el-descriptions-item span="3">
          <template slot="label"><i class="el-icon-warning-outline"></i>网关</template>
          {{dataDetail.userFactId|dict(userFactIdCacheListCopy)}}
          >
          {{dataDetail.userStoreId|dict(userStoreIdCacheListCopy)}}
          >
          {{dataDetail.userPointId|dict(userPointIdCacheListCopy)}}
          >
          {{dataDetail.userGwId|dict(userGwIdCacheListCopy)}}
        </el-descriptions-item>
        <el-descriptions-item span="3">
          <template slot="label"><i class="el-icon-office-building"></i>设备地址</template>
          {{dataDetail.userDevAddr}}
        </el-descriptions-item>
        <el-descriptions-item span="3">
          <template slot="label"><i class="el-icon-office-building"></i>安装地址</template>
          {{dataDetail.addr}}
        </el-descriptions-item>
        <el-descriptions-item span="3">
          <template slot="label"><i class="el-icon-tickets"></i>物理序号</template>
          {{dataDetail.sn}}
        </el-descriptions-item>
        <el-descriptions-item span="3">
          <template slot="label"><i class="el-icon-tickets"></i>报警公式</template>
          {{dataDetail.alertExp}}
        </el-descriptions-item>
        <el-descriptions-item span="3">
          <template slot="label"><i class="el-icon-tickets"></i>定时任务</template>
          {{dataDetail.timeTask}}
        </el-descriptions-item>
        <el-descriptions-item span="3">
          <template slot="label"><i class="el-icon-tickets"></i>在线说明</template>
          {{dataDetail.lineDesc}}
        </el-descriptions-item>
        <el-descriptions-item span="3">
          <template slot="label"><i class="el-icon-tickets"></i>在线信息</template>
          {{dataDetail.lineMsg}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-tickets"></i>设备密码</template>
          {{dataDetail.userDevPwd}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-tickets"></i>定时(s)</template>
          {{dataDetail.timeTaskDelay}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-open"></i>状态</template>
          {{dataDetail.status|dict(dictStatus)}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-open"></i>在线状态</template>
          {{dataDetail.lineStatus|dict(dictLineStatus)}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-tickets"></i>温度</template>
          {{dataDetail.value1|append('℃')}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-tickets"></i>{{userInfo.userHumName}}</template>
          {{dataDetail.value2|append(userInfo.userHumUnit)}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-user-solid"></i>最后操作员</template>
          {{dataDetail.operatorId}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-time"></i>创建时间</template>
          {{dataDetail.createTime}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-time"></i>更新时间</template>
          {{dataDetail.updateTime}}
        </el-descriptions-item>
      </el-descriptions>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogDetail=false" size="small">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 添加弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogAdd" width="700px" @closed="onResetForm('formAdd')" top="8vh">
      <template slot="title"><i class="el-icon-document-add" /> 添加设备</template>
      <el-form :model="formAdd" ref="formAdd" :rules="formAddRules" size="small" inline label-width="110px">
        <el-form-item label="设备名称" prop="userDevName">
          <el-input class="width-2-2" v-model="formAdd.userDevName" placeholder="请输入设备名称" maxlength="64" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="设备描叙" prop="userDevDesc">
          <el-input class="width-2-2" type="textarea" v-model="formAdd.userDevDesc" placeholder="请输入设备描叙" maxlength="256" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="商户设备" prop="merDevId">
          <select-tree class="width-2-2" ref="merDevIdAddTree" :options="merDevIdCacheTreeList" :defaultProps="pageDefaultProps" @input="merDevIdOnAddSelect" :multiple="false"></select-tree>
        </el-form-item>
        <el-form-item label="网关" prop="userGwId">
          <select-tree class="width-2-2" ref="userGwIdAddTree" :options="userGwIdCacheTreeList" :defaultProps="pageDefaultProps" @input="userGwIdOnAddSelect" :multiple="false"></select-tree>
        </el-form-item>
        <el-form-item label="设备地址" prop="userDevAddr">
          <el-input class="width-2-2" v-model="formAdd.userDevAddr" placeholder="请输入设备地址" maxlength="32" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="设备密码" prop="userDevPwd">
          <el-input class="width-2-2" v-model="formAdd.userDevPwd" placeholder="请输入设备密码" maxlength="256" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="安装地址" prop="addr">
          <el-input class="width-2-2" v-model="formAdd.addr" placeholder="请输入安装地址" maxlength="512" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="物理序号" prop="sn">
          <el-input class="width-2-2" v-model="formAdd.sn" placeholder="请输入物理序号" maxlength="256" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="报警公式" prop="alertExp">
          <el-input class="width-2-2" v-model="formAdd.alertExp" placeholder="请输入报警公式" maxlength="1048" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="定时(s)" prop="timeTaskDelay">
          <el-input class="width-2-2" v-model="formAdd.timeTaskDelay" placeholder="请输入定时(s)" clearable></el-input>
        </el-form-item>
        <el-form-item label="定时任务" prop="timeTask">
          <el-input class="width-2-2" v-model="formAdd.timeTask" placeholder="请输入定时任务" maxlength="4096" show-word-limit clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onSubmitAdd()" size="small">提 交</el-button>
        <el-button @click="dialogAdd=false" size="small">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 编辑弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogModify" width="700px" @opened="onEditTreeInit" @closed="onResetForm('formEdit')" top="8vh">
      <template slot="title"><i class="el-icon-edit" /> 编辑设备</template>
      <el-form :model="formEdit" ref="formEdit" :rules="formEditRules" size="small" inline label-width="110px">
        <el-form-item label="设备名称" prop="userDevName">
          <el-input class="width-2-2" v-model="formEdit.userDevName" placeholder="请输入设备名称" maxlength="64" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="设备描叙" prop="userDevDesc">
          <el-input class="width-2-2" type="textarea" v-model="formEdit.userDevDesc" placeholder="请输入设备描叙" maxlength="256" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="商户设备" prop="merDevId">
          <select-tree class="width-2-2" ref="merDevIdEditTree" :options="merDevIdCacheTreeList" :EObjArr="merDevIdEditTreeDef" :defaultProps="pageDefaultProps" @input="merDevIdOnEditSelect" :multiple="false"></select-tree>
        </el-form-item>
        <el-form-item label="网关" prop="userGwId">
          <select-tree class="width-2-2" ref="userGwIdEditTree" :options="userGwIdCacheTreeList" :EObjArr="userGwIdEditTreeDef" :defaultProps="pageDefaultProps" @input="userGwIdOnEditSelect" :multiple="false"></select-tree>
        </el-form-item>
        <el-form-item label="设备地址" prop="userDevAddr">
          <el-input class="width-2-2" v-model="formEdit.userDevAddr" placeholder="请输入设备地址" maxlength="32" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="设备密码" prop="userDevPwd">
          <el-input class="width-2-2" v-model="formEdit.userDevPwd" placeholder="请输入设备密码" maxlength="256" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="安装地址" prop="addr">
          <el-input class="width-2-2" v-model="formEdit.addr" placeholder="请输入安装地址" maxlength="512" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="物理序号" prop="sn">
          <el-input class="width-2-2" v-model="formEdit.sn" placeholder="请输入物理序号" maxlength="256" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="报警公式" prop="alertExp">
          <el-input class="width-2-2" v-model="formEdit.alertExp" placeholder="请输入报警公式" maxlength="1048" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="定时(s)" prop="timeTaskDelay">
          <el-input class="width-2-2" v-model="formEdit.timeTaskDelay" placeholder="请输入定时(s)" clearable></el-input>
        </el-form-item>
        <el-form-item label="定时任务" prop="timeTask">
          <el-input class="width-2-2" v-model="formEdit.timeTask" placeholder="请输入定时任务" maxlength="4096" show-word-limit clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onSubmitEdit()" size="small">提 交</el-button>
        <el-button @click="onResetEdit" size="small">重 置</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import axios from 'axios' // 引入页面处理
import selectTree from '@/components/selectTreeObj.vue' // 引入下拉树

export default {
  name: 'userplatDevUserdev',
  components: { // 组件
    selectTree // 关联下拉树
  },
  data () {
    return {
      menuName: 'userplatDevUserdev',
      cardTreeHeigth: window.innerHeight - 100 + 'px',
      formQuery: { // 查询对象
        userDevName: '', // 设备名称
        sn: '', // 物理序号
        status: '', // 状态
        lineStatus: '', // 在线状态
        userFactId: '', // 工厂
        userStoreId: '', // 仓库
        userPointId: '', // 点位
        userGwId: '' // 网关
      },
      formAdd: { // 新增对象
        userDevName: '', // 设备名称
        userDevDesc: '', // 设备描叙
        produerId: '', // 厂商
        devId: '', // 厂商设备
        merId: '', // 商户
        merGwId: '', // 商户网关
        merDevId: '', // 商户设备
        userFactId: '', // 工厂
        userStoreId: '', // 仓库
        userPointId: '', // 点位
        userGwId: '', // 网关
        userDevAddr: '', // 设备地址
        userDevPwd: '', // 设备密码
        addr: '', // 安装地址
        sn: '', // 物理序号
        alertExp: '', // 报警公式
        timeTaskDelay: '', // 定时(s)
        timeTask: '' // 定时任务
      },
      formAddRules: { // 新增规则
        userDevName: [{ required: true, message: '请输入设备名称', trigger: 'blur' }],
        merDevId: [{ required: true, message: '请输入商户设备', trigger: 'blur' }],
        userGwId: [{ required: true, message: '请输入网关', trigger: 'blur' }],
        sn: [{ required: true, message: '请输入物理序号', trigger: 'blur' }]
      },
      formEditRules: { // 更新规则
        userDevName: [{ required: true, message: '请输入设备名称', trigger: 'blur' }],
        merDevId: [{ required: true, message: '请输入商户设备', trigger: 'blur' }],
        userGwId: [{ required: true, message: '请输入网关', trigger: 'blur' }],
        sn: [{ required: true, message: '请输入物理序号', trigger: 'blur' }]
      },
      dictStatus: [], // 状态
      dictLineStatus: [], // 在线状态
      produerIdCacheList: [],
      produerIdCacheListCopy: [],
      devIdCacheList: [],
      devIdCacheListCopy: [],
      merIdCacheList: [],
      merIdCacheListCopy: [],
      merGwIdCacheList: [],
      merGwIdCacheListCopy: [],
      merDevIdCacheList: [],
      merDevIdCacheListCopy: [],
      userFactIdCacheList: [],
      userFactIdCacheListCopy: [],
      userStoreIdCacheList: [],
      userStoreIdCacheListCopy: [],
      userPointIdCacheList: [],
      userPointIdCacheListCopy: [],
      userGwIdCacheList: [],
      userGwIdCacheListCopy: [],
      merDevIdCacheTreeList: [],
      merDevIdCacheTreeListCopy: [],
      userGwIdCacheTreeList: [],
      userGwIdCacheTreeListCopy: [],
      merDevIdEditTreeDef: [],
      userGwIdEditTreeDef: [],
      idName: 'userDevId',
      httpUrl: '/dev/userDev',
      httpUri: {
        produerIdCacheUri: '/cache/devProd',
        devIdCacheUri: '/cache/devDev',
        merIdCacheUri: '/cache/merInfo',
        merGwIdCacheUri: '/cache/merGw',
        merDevIdCacheUri: '/cache/merDev',
        userFactIdCacheUri: '/cache/userFactory',
        userStoreIdCacheUri: '/cache/userStore',
        userPointIdCacheUri: '/cache/userPoint',
        userGwIdCacheUri: '/cache/userGw',
        merDevIdCacheTreeUri: '/cacheTree/merDev',
        userGwIdCacheTreeUri: '/cacheTree/userGw',
        userTree: '/user/userTree/gw'
      },
      divLevel: [],
      divTree: {},
      refreshSpace: 5000,
      refreshTimer: null,
      refreshAuto: false,
      userTree: [],
      userTreeDefExpa: [],
      userSearch: '',
      devSearch: '',
      merSearch: '',
      elTreeLeftShow: false
    }
  },
  watch: {
    'formQuery.userFactId': {
      handler (curVal, oldVal) {
        this.onSelectChange(curVal, 'userFactIdCacheList', 'userStoreIdCacheList', this.httpUri.userStoreIdCacheUri, this.formQuery, 'userStoreId', true, { userFactId: curVal })
      }
    },
    'formQuery.userStoreId': {
      handler (curVal, oldVal) {
        this.onSelectChange(curVal, 'userStoreIdCacheList', 'userPointIdCacheList', this.httpUri.userPointIdCacheUri, this.formQuery, 'userPointId', true, { userStoreId: curVal })
      }
    },
    'formQuery.userPointId': {
      handler (curVal, oldVal) {
        this.onSelectChange(curVal, 'userPointIdCacheList', 'userGwIdCacheList', this.httpUri.userGwIdCacheUri, this.formQuery, 'userGwId', true, { userPointId: curVal })
      }
    },
    $route (to, from) {
      this.routeTree(to)
    },
    userSearch (val) {
      this.$refs.userTree.filter(val)
    }
  },
  mounted () {
    this.mountedTree()
    if (Object.keys(this.$route.query).length) {
      this.httpQuery()
    }
    this.getSysDict('STATUS_TYPE', 'dictStatus', 'getStatus')
    this.getSysDict('LINE_STATUS', 'dictLineStatus', 'getLineStatus')
    this.httpSelectList('produerIdCacheList', this.httpUri.produerIdCacheUri)
    this.httpSelectList('devIdCacheList', this.httpUri.devIdCacheUri)
    this.httpSelectList('merIdCacheList', this.httpUri.merIdCacheUri)
    this.httpSelectList('merGwIdCacheList', this.httpUri.merGwIdCacheUri)
    this.httpSelectList('merDevIdCacheList', this.httpUri.merDevIdCacheUri)
    this.httpSelectList('userFactIdCacheList', this.httpUri.userFactIdCacheUri)
    this.httpSelectList('userStoreIdCacheList', this.httpUri.userStoreIdCacheUri)
    this.httpSelectList('userPointIdCacheList', this.httpUri.userPointIdCacheUri)
    this.httpSelectList('userGwIdCacheList', this.httpUri.userGwIdCacheUri)
    this.httpSelectList('merDevIdCacheTreeList', this.httpUri.merDevIdCacheTreeUri)
    this.httpSelectList('userGwIdCacheTreeList', this.httpUri.userGwIdCacheTreeUri)
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }
    this.httpUserTree()
  },
  activated () {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }
    if (this.refreshAuto) {
      this.refreshTimer = window.setInterval(this.httpQuery, this.refreshSpace)
    }
  },
  deactivated () {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }
  },
  beforeDestroy () {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }
  },
  methods: {
    onQuery () {
      const [id, type] = this.getQuery(this)
      this.getDivLevel(id, type)
      this.onPageQuery(this)
    },
    onAddTreeInit () {
      this.$refs.merDevIdAddTree.init()
      this.$refs.userGwIdAddTree.init()
    },
    merDevIdOnAddSelect (node, val) {
      this.formAdd.merDevId = node.value
      this.formAdd.devId = node.params.devId
      this.formAdd.produerId = node.params.produerId
      this.formAdd.merId = node.params.merId
      this.formAdd.merGwId = node.params.merGwId
    },
    userGwIdOnAddSelect (node, val) {
      this.formAdd.userGwId = node.value
      this.formAdd.userPointId = node.params.userPointId
      this.formAdd.userStoreId = node.params.userStoreId
      this.formAdd.userFactId = node.params.userFactId
    },
    onEditTreeDefInit (data) {
      this.merDevIdEditTreeDef = this.getTreeDef(this.merDevIdCacheTreeList, data.merDevId)
      this.userGwIdEditTreeDef = this.getTreeDef(this.userGwIdCacheTreeList, data.userGwId)
    },
    onEditTreeInit () {
      this.$refs.merDevIdEditTree.init()
      this.$refs.userGwIdEditTree.init()
    },
    merDevIdOnEditSelect (node, val) {
      this.formEdit.merDevId = node.value
      this.formEdit.devId = node.params.devId
      this.formEdit.produerId = node.params.produerId
      this.formEdit.merId = node.params.merId
      this.formEdit.merGwId = node.params.merGwId
    },
    userGwIdOnEditSelect (node, val) {
      this.formEdit.userGwId = node.value
      this.formEdit.userPointId = node.params.userPointId
      this.formEdit.userStoreId = node.params.userStoreId
      this.formEdit.userFactId = node.params.userFactId
    },
    onRefreshAuto (val) {
      if (this.refreshTimer) {
        clearInterval(this.refreshTimer)
      }
      if (val) {
        this.refreshTimer = window.setInterval(this.httpQuery, this.refreshSpace)
      }
    },
    onUserTreeClick (data) {
      let type = data.type
      let id = data.id
      this.getDivLevel(id, type)
      this.putQuery(id, type)
      this.httpQuery()
    },
    onTreeFilter (value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    httpUserTree () {
      axios({
        url: this.baseUrl + this.httpUri.userTree,
        method: 'get'
      }).then(res => {
        if (res.data.code === '0000') {
          this.userTree = res.data.data
          this.getDivLevel(this.divTree.id, this.divTree.type)
        }
      }).catch(err => {
        console.log(err, 'loginerr')
      })
    },
    removeTip (row) {
      let sn = row.sn + '/' + row.userDevAddr
      return `主设备名称：${row.userDevName}<br/>识别码：${sn}<br/>确认要删除该主设备？`
    }
  }
}
</script>

<style scoped>
@import "../../assets/page.css";

div.width-2-2 {
    width: 520px;
}
</style>
